import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { GlobalStyle } from "./constants/DefaultStyles";
import NavWrapper from "./components/NavWrapper/NavWrapper";
import { publicRoutes } from "./components/NavWrapper/Menus.consts";
import LoadingWrapper from "./components/LoadingWrapper";
import {
  generatePrivateRoutes,
  generatePublicRoutes,
} from "./components/NavWrapper/RenderRoutes";
import ErrorWrapper from "./components/ErrorWrapper";

const App: React.FC = () => {
  const current_version = "1.002";

  console.log(`Versão atual v${current_version}`);

  return (
    <>
      <LoadingWrapper />
      <ErrorWrapper />
      <ToastContainer />
      <GlobalStyle />
      <Router>
        <Routes>
          {generatePublicRoutes()}
          <Route element={<NavWrapper />}>{generatePrivateRoutes()}</Route>
          <Route
            path="*"
            element={<Navigate to={publicRoutes.default.path} />}
          />
        </Routes>
      </Router>
    </>
  );
};

export default App;
